import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class GameRoundHistoryConfig {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getGameRoundHistoryByGameIdProviders(): string[] {
		return this.config.get((c) => c.common.gameRoundHistory.gameRoundHistoryByGameId.providers);
	}
}
